<template>
    <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-25">
        <md-card class="md-card-product md-card-website"
                 @mouseleave.native="onMouseLeave">
            <md-card-header @mouseenter.native="onMouseOver"
                            :data-header-animation="true"
                            :class="{ hovered: imgHovered }"
                            class="md-card-header-image animated">
                <img class="img" :src="website.imgUrl" />
            </md-card-header>

            <md-card-content>
                <div class="md-card-action-buttons text-center">
                    <md-button class="md-simple md-just-icon" :href="website.url" target="_blank">
                        <md-icon>art_track</md-icon>
                        <md-tooltip md-direction="bottom">View Website</md-tooltip>
                    </md-button>
                    <md-button class="md-success md-simple md-just-icon" :to="editBuildingUrl">
                        <md-icon>edit</md-icon>
                        <md-tooltip md-direction="bottom">Edit Building</md-tooltip>
                    </md-button>
                    <!--<md-button class="md-danger md-simple md-just-icon">
                        <md-icon>close</md-icon>
                        <md-tooltip md-direction="bottom">Take Offline</md-tooltip>
                    </md-button>-->
                </div>
                <h4 class="title">
                    <a :href="website.url" target="_blank" title="View website in new tab">{{website.name}}</a>
                </h4>
                <div class="card-description">
                    {{website.description}}
                </div>
            </md-card-content>
            <md-card-actions md-alignment="space-between">
                <div class="stats">
                    <p class="category">
                        <md-icon>place</md-icon>
                        {{ website.shortAddress }}
                    </p>
                </div>
                <div class="price">
                    <h4>&pound;{{ new Intl.NumberFormat({ style: 'currency' }).format(website.serviceCharge) }} <small>S/C</small></h4>
                </div>
            </md-card-actions>
        </md-card>
   </div>
</template>
<script>
    export default {
        name: "WebsiteCard",
        props: {
            website: {}
        },
        data() {
            return {
                imgHovered: false
            };
        },
        computed: {
            editBuildingUrl() {
                return `/buildings/${this.website.id}/complete`
            }
        },
        methods: {
            onMouseOver: function () {
                    this.imgHovered = true;
            },
            onMouseLeave: function () {
                    this.imgHovered = false;
            }
        }
    };
</script>
